import { useRef, useState, memo } from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    MenuItem,
    Select,
    TextField,
    LinearProgress,
    makeStyles
} from '@material-ui/core'

import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close'

import { SpacedGroup } from 'UI/Components'

import { useBoolean, useDictionary } from 'hooks'

import { areObjectsEqual } from 'modules'

const useStyles = makeStyles(theme => ({
    title: {
        fontSize: '1.5rem',
        textAlign: 'center',
        fontWeight: theme.typography.fontWeightBold
    },
    text: {
        textAlign: 'center',
        color: theme.palette.grey
    },
    closeButton: {
        position: 'absolute',
        right: 0,
        top: 0,
        padding: theme.spacing(0.5),
        margin: theme.spacing(0.5)
    },
    actions: {
        padding: theme.spacing(3),
        justifyContent: 'center'
    }
}))

export const EditDictionaryWordDialog = memo(({ editData, onClose, setDeleteId }) => {
    const classes = useStyles()
    const { dictionariesTypes, updatePhrase } = useDictionary()
    const loading = useBoolean(false)

    const archive = useRef(editData)
    const [data, setData] = useState(editData)

    const handleEdit = () => {
        loading.setTrue()
        updatePhrase(data).then(onClose).finally(loading.setFalse)
    }

    const disableSave = loading.isTrue || areObjectsEqual(archive.current, data)

    return (
        <Dialog open onClose={onClose} fullWidth={true} maxWidth="xs">
            {loading.isTrue && <LinearProgress />}
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
            </IconButton>

            <DialogTitle>
                <Typography className={classes.title}>Edit dictionary phrase</Typography>
            </DialogTitle>
            <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
                <SpacedGroup style={{ alignItems: 'flex-end' }}>
                    <TextField
                        label="Add phrase"
                        placeholder="Enter phrase"
                        value={data.phrase}
                        onChange={e => {
                            e.persist()
                            setData(prev => ({
                                ...prev,
                                phrase: e.target?.value
                            }))
                        }}
                    />
                    <Select
                        value={data.description}
                        onChange={e => {
                            e.persist()
                            setData(prev => ({
                                ...prev,
                                description: e.target.value
                            }))
                        }}
                        style={{ minWidth: '120px' }}
                        displayEmpty
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {dictionariesTypes.map((type, i) => (
                            <MenuItem key={i} value={type.value}>
                                {type.name}
                            </MenuItem>
                        ))}
                    </Select>
                </SpacedGroup>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button size="medium" color="default" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    size="medium"
                    onClick={handleEdit}
                    disabled={disableSave}
                    endIcon={<EditIcon />}
                >
                    Save
                </Button>

                <Button onClick={() => setDeleteId(data.id)} endIcon={<DeleteIcon />}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
})
